var moduleMap = {
	"./httpClient": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(705), __webpack_require__.e(988)]).then(() => (() => ((__webpack_require__(62465)))));
	},
	"./contract": () => {
		return Promise.all([__webpack_require__.e(96), __webpack_require__.e(705), __webpack_require__.e(520), __webpack_require__.e(988), __webpack_require__.e(327), __webpack_require__.e(105)]).then(() => (() => ((__webpack_require__(79105)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});